import { AvailableMFA } from '../../../constants/mfa'
import Box from '@talkdesk/cobalt-react-box'
import IconWithProvider from '@talkdesk/cobalt-react-icon'
import Flex from '@talkdesk/cobalt-react-flex'
import { Heading, Text } from '@talkdesk/cobalt-react-typography'
import Card from '@talkdesk/cobalt-react-card'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'

const RenderMFACard = ({ icon, color, name, description, theme }) => (
  <Flex gap='4' alignY='center'>
    <IconWithProvider name={icon} size='medium' color={color} />
    <Box>
      <Heading level='3' asLevel='5'>
        {name}
      </Heading>
      <Text color={theme.gray600}>{description}</Text>
    </Box>
  </Flex>
)

const SetupMFACard = ({ mfaType, onClick }) => {
  const theme = useTheme()
  return (
    <Card onClick={onClick}>
      <Flex padding='4' gap='4' alignY='center' alignX='space-between'>
        <RenderMFACard {...AvailableMFA[mfaType.toUpperCase()]} theme={theme} />
        <IconWithProvider
          name='chevron_right'
          size='small'
          color={theme.gray500}
        />
      </Flex>
    </Card>
  )
}

export default SetupMFACard
